import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import './app/core/extensions/string/string.extension';

bootstrapApplication(App, appConfig())
  .catch((err) => console.error(err));
